import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import StartProfessionalCareConversation from "./sections/StartProfessionalCareConversation";
import RangeHoodInstallation from "./sections/RangeHoodInstallation";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <StartProfessionalCareConversation />
      <RangeHoodInstallation />
      <Footer />
    </div>;
}